import { createApp } from 'vue'
import { createPinia } from 'pinia'
import '@unocss/reset/tailwind.css'
import 'uno.css'
import Clarity from '@microsoft/clarity'
import App from './App.vue'
import { router } from './router'
import { environments } from '@/config/brands'
import { fetchAppConfig } from '@/composables/useAppConfig'

// 获取客户端配置
fetchAppConfig()

// 生产环境和测试环境集成 Clarity
if (import.meta.env.MODE.includes('production') || import.meta.env.MODE.includes('testing')) {
  const mode = import.meta.env.MODE as keyof typeof environments
  const clarityId = environments[mode]?.clarityId
  if (clarityId)
    Clarity.init(clarityId)
}

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.mount('#app')
